import React, { useEffect } from 'react';
import { useState } from 'react';
import './Contact.css';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import CountDown from './CountDown';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const Contact = ({ user, handleOpen }) => {
    const [profession, setProfession] = useState('')
    const [message, setMessage] = useState('')
    const [successAlert, setSuccessAlert] = useState(false)
    const [errorAlert, setErrorAlert] = useState(false)
    const [dateInfo, setDateInfo] = useState('')
    const [isSentMessage, setIsSentMessage] = useState(true)


    fetch("https://tajuddin-portfolio-database.herokuapp.com/getUserInformation")
    .then(res => res.json())
    .then(data => {
        const GetUserInfo = user && data.find(item => item.contact === user.email)
        GetUserInfo && setDateInfo(GetUserInfo.readDate)
        GetUserInfo && setIsSentMessage(false)
    })
    .catch(err => {
    })

    const ContactHandler = async (e) => {
        e.preventDefault()
        e.target.reset()
        const UName = document.getElementById('contactName').value;
        const UContact = document.getElementById('quickContact').value;
        const SentDate = new Date().toISOString()
        const FetchData = {
            name: UName,
            profession,
            contact: UContact,
            message,
            readDate: SentDate
        }
        await fetch("https://tajuddin-portfolio-database.herokuapp.com/sentContact", {
            method: 'POST',
            headers: {
                "Content-type": "application/json; charset=UTF-8"
            },
            body: JSON.stringify(FetchData)
        })
        .then(data => {
            setMessage('')
            setSuccessAlert(true)
            const testDate = new Date().toISOString()
            setDateInfo(testDate)
            setIsSentMessage(false)
        })
        .catch(err => {
            setMessage('')
            setErrorAlert(true)
        })
    }
    return (
        <section className='contact' id='contact'>
            <h1 className='title' data-aos='zoom-in'>Contact</h1>
            <div className='contact_main_container'>
                {
                    isSentMessage ?
                    <form onSubmit={(e) => ContactHandler(e)} className='contact_main_area'>
                    <label htmlFor="contactName">Name :</label>
                    <input type="text" id="contactName" placeholder='Enter Your Full Name*' value={user ? user.name : ''} />
                    <label htmlFor="quickContact">Your Email :</label>
                    <input type='text' id="quickContact" placeholder='Add Your Phone Or Email*' value={user ? user.email : ''}/>
                    <label htmlFor="contactProfession">Profession :</label>
                    <input type="text" id="contactProfession" placeholder='Whats Your Profession*' onBlur={(e) => setProfession(e.target.value)} required/>
                    <label htmlFor="contactMessage">Message :</label>
                    <textarea maxLength='500' minLength='30' id="contactMessage" cols="30" rows="10" placeholder='Write Your Message*' onChange={(e) => setMessage(e.target.value)} required>
                    </textarea>
                    <span>{message.length} / 500</span>
                    {
                        !user &&
                        <p className='text-center'>If you are logged in do submit otherwise <span onClick={handleOpen} className='contact_login_btn'>login</span> first</p>
                    }
                    {
                        user ?
                        <input type="submit" value='Submit' className='mt-4 contact_submit'/> :
                        <input type="submit" value='Submit' className='mt-4 contact_submit cursor-not-allowed' disabled/>
                    }
                </form> :
                <CountDown dateTime={dateInfo}/>
                }
            </div>
            <Snackbar open={successAlert} autoHideDuration={8000}>
                <Alert onClose={() => setSuccessAlert(false)} severity="success">
                Successfully sent your message. As soon as possible I reply to you in 24 hours.
                </Alert>
            </Snackbar>
            <Snackbar open={errorAlert} autoHideDuration={8000}>
                <Alert onClose={() => setErrorAlert(false)} severity="error">
                Having some issue. Please try to again
                </Alert>
            </Snackbar>
        </section>
    );
};

export default Contact;